import React from "react";
import { Button } from "@material-ui/core";
import renderHTML from "react-render-html";
import axios from "axios";
import apiURL from "../../config/api.json";
import { getFromStorage } from "../../utils/storage.js";

const Html = () => {
  const html = getFromStorage("html") ? getFromStorage("html") : "";
  const case_id = getFromStorage("View") ? getFromStorage("View").case_id : "";
  const docDownload = () => {
    const body = {
      task: "getPresignedURL",
      req_type: "get",
      object_name: `httpFiles/mswordReports/${case_id}/${case_id}.docx`
    }
    axios
      .post(apiURL.postMethodURL, body, {
        headers: { "Content-Type": "application/json" }
      })
      .then(res => {
        if(!res.data.error) {
          window.open(res.data)
        }
      })
      .catch(err => {
        console.log(err)
      });
  };
  return (
    <div
      style={{
        paddingLeft: "20px",
        paddingRight: "20px",
        backgroundColor: "white",
        paddingBottom: "110px"
      }}
    >
      <br />
      <Button
        variant="contained"
        color="primary"
        style={{
          textTransform: "none",
          width: "300px"
        }}
        onClick={docDownload}
      >
        Save as .doc{" "}
      </Button>
      <br />
      <br />
      {renderHTML(html)}
    </div>
  );
};
export default Html;
